<template>
  <div id="dashboard-banking" v-if="showWindow">
    <div class="vx-row w-full">
        <div class="vx-col w-1/2" v-if="tableData1.length>0">
          <h3>Groups</h3>
          <vs-table max-items="5" pagination :data="tableData1">
            <template slot="thead">
                <vs-th>wr_id</vs-th>
                <vs-th>created_at</vs-th>
                <vs-th>brand</vs-th>
                <vs-th>reference</vs-th>
                <vs-th>status_name</vs-th>
                <vs-th>tran_type</vs-th>
                <vs-th>from_account</vs-th>
                <vs-th>out_coin</vs-th>
                <vs-th>amount</vs-th>
                <vs-th>to_account</vs-th>
                <vs-th>in_coin</vs-th>
                <vs-th>value</vs-th>
                <vs-th>rate</vs-th>
                <vs-th>commi</vs-th>
                <vs-th>commi_cur</vs-th>
                <vs-th>spared</vs-th>
                <vs-th>acquited</vs-th>
                <vs-th>last_updated</vs-th>
            </template>

            <template slot-scope="{data}">
                <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                   <vs-td :data="data[indextr].wr_id">
                        {{data[indextr].wr_id}}
                    </vs-td>
                    <vs-td :data="data[indextr].created_at">
                        {{data[indextr].created_at}}
                    </vs-td>
                    <vs-td :data="data[indextr].brand">
                        {{data[indextr].brand}}
                    </vs-td>
                    <vs-td :data="data[indextr].reference">
                        {{data[indextr].reference}}
                    </vs-td>
                    <vs-td :data="data[indextr].status_name">
                        {{data[indextr].status_name}}
                    </vs-td>
                    <vs-td :data="data[indextr].tran_type">
                        {{data[indextr].tran_type}}
                    </vs-td>
                    <vs-td :data="data[indextr].from_account">
                        {{data[indextr].from_account}}
                    </vs-td>
                    <vs-td :data="data[indextr].out_coin">
                        {{data[indextr].out_coin}}
                    </vs-td>
                    <vs-td :data="data[indextr].amount">
                        {{data[indextr].amount}}
                    </vs-td>
                    <vs-td :data="data[indextr].to_account">
                        {{data[indextr].to_account}}
                    </vs-td>
                    <vs-td :data="data[indextr].in_coin">
                        {{data[indextr].in_coin}}
                    </vs-td>
                    <vs-td :data="data[indextr].value">
                        {{data[indextr].value}}
                    </vs-td>
                    <vs-td :data="data[indextr].rate">
                        {{data[indextr].rate}}
                    </vs-td>
                    <vs-td :data="data[indextr].commi">
                        {{data[indextr].commi}}
                    </vs-td>
                    <vs-td :data="data[indextr].commi_cur">
                        {{data[indextr].commi_cur}}
                    </vs-td>
                    <vs-td :data="data[indextr].spared">
                        {{data[indextr].spared}}
                    </vs-td>
                    <vs-td :data="data[indextr].acquited">
                        {{data[indextr].acquited}}
                    </vs-td>
                    <vs-td :data="data[indextr].last_updated">
                        {{data[indextr].last_updated}}
                    </vs-td>
                </vs-tr>
            </template>
        </vs-table>
        </div>
        <div class="vx-col w-1/2" v-if="tableData2.length>0">
          <h3>Journey</h3>
          <vs-table max-items="5" pagination :data="tableData2">
            <template slot="thead">
                <vs-th>tg_id</vs-th>
                <vs-th>created_at</vs-th>
                <vs-th>brand</vs-th>
                <vs-th>reference</vs-th>
                <vs-th>group_status</vs-th>
                <vs-th>current_account</vs-th>
                <vs-th>current_amount</vs-th>
                <vs-th>current_cur</vs-th>
                <vs-th>tl_id_string</vs-th>
                <vs-th>commi_cur</vs-th>
                <vs-th>expected_commi</vs-th>
                <vs-th>last_updated</vs-th>
            </template>

            <template slot-scope="{data}">
                <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                   <vs-td :data="data[indextr].tg_id">
                        {{data[indextr].tg_id}}
                    </vs-td>
                    <vs-td :data="data[indextr].created_at">
                        {{data[indextr].created_at}}
                    </vs-td>
                    <vs-td :data="data[indextr].brand">
                        {{data[indextr].brand}}
                    </vs-td>
                    <vs-td :data="data[indextr].reference">
                        {{data[indextr].reference}}
                    </vs-td>
                    <vs-td :data="data[indextr].group_status">
                        {{data[indextr].group_status}}
                    </vs-td>
                    <vs-td :data="data[indextr].current_account">
                        {{data[indextr].current_account}}
                    </vs-td>
                    <vs-td :data="data[indextr].current_amount">
                        {{data[indextr].current_amount}}
                    </vs-td>
                    <vs-td :data="data[indextr].current_cur">
                        {{data[indextr].current_cur}}
                    </vs-td>
                    <vs-td :data="data[indextr].tl_id_string">
                        {{data[indextr].tl_id_string}}
                    </vs-td>
                    <vs-td :data="data[indextr].commi_cur">
                        {{data[indextr].commi_cur}}
                    </vs-td>
                    <vs-td :data="data[indextr].expected_commi">
                        {{data[indextr].expected_commi}}
                    </vs-td>
                    <vs-td :data="data[indextr].last_updated">
                        {{data[indextr].last_updated}}
                    </vs-td>
                </vs-tr>
            </template>
        </vs-table>
        </div>
      </div>
  </div>
</template>

<script>
import axios from "@/axios.js"
export default {
    data() {
        return {
          tableData1:[],
          tableData2:[],
        }
  },
    components: {
      
    },
    computed:{
      showWindow(){
        if(this.$route.path==='/banking/dashboard'){
            this.callTable1();
            this.callTable2();
        }
        return []
      },
    },
    methods: {
      openStory: function(){
        this.$router.push("/business/story").catch(() => {})
      },
      callTable1: function(){
        const params = new URLSearchParams();
        params.append('type', 'banking_journey');
        axios.post("/api/banking",params)
        .then((response) => {
          this.tableData1 = response.data;
        })
        .catch((error) => { console.log('error',error) })
      },
      callTable2: function(){
        const params = new URLSearchParams();
        params.append('type', 'banking_groups');
        axios.post("/api/banking",params)
        .then((response) => {
          this.tableData2 = response.data;
        })
        .catch((error) => { console.log('error',error) })
      }

    }
}
</script>

<style lang="scss">
/*! rtl:begin:ignore */
#dashboard-analytics {
  .vs-table{
    overflow-x:scroll !important
  }
  @media(max-width: 576px) {
    .decore-left, .decore-right{
      width: 140px;
    }
  }
}
/*! rtl:end:ignore */
</style>
